import axiosInstance from '@/services/axiosInstance'
import mock from '@/services/mock/index'

async function emitirFacturaRectificativa (files = [], params = null) {
  if (process.env.VUE_APP_ENVIRONMENT === 'test') {
    return new Promise((resolve, reject) => {
      resolve(mock.getTipoEsquema)
    })
  } else {
    let formData = null
    if (files?.length) {
      formData = new FormData()
      files.forEach(file => {
        formData.append('file', file.raw)
      })
    }

    const req = {
      url: 'api/facturas/emitirfacturarectificativa',
      method: 'POST',
      headers: {
        'Content-type': 'application/json',
      },
      params,
      data: formData,
    }
    const res = await axiosInstance(req)
    return res.data
  }
}

export { emitirFacturaRectificativa }
